export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13355.89afe711.jpg";